import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PackageConfigurationEntity} from "../../models/package-configuration.model";

export class PackageConfigurationsTableComponent implements IController {
  packageConfigurations: PackageConfigurationEntity[];
  packageConfigurationCopy: PackageConfigurationEntity;
  query: string;
  editConfigurationIndex: number;
  sitePackageItems: any;
  onEditPackageConfigurationClicked: Function;
  onAddNewField: Function;
  onPackageConfigurationChanged: Function;
  onDuplicateConfigurationClicked: Function;

  public packageItemsConfigurationMap: {} = {};


  $onInit() {
    this.packageConfigurations.forEach((packageConfiguration: PackageConfigurationEntity) => {
      this.packageItemsConfigurationMap[packageConfiguration.id] = this.sitePackageItems.filter(packageItem => {
        return packageItem.packageConfigurationId === packageConfiguration.id
      });
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationsTable', {
    require: {
      form: '^form'
    },
    bindings: {
      packageConfigurations: '<?',
      packageConfigurationCopy: '<?',
      query: '<?',
      editConfigurationIndex: '<?',
      sitePackageItems: '<',
      onEditPackageConfigurationClicked: '&',
      onAddNewField: '&',
      onPackageConfigurationChanged: '&',
      onDuplicateConfigurationClicked: '&',
    },
    template: require('./package-configurations-table.html').default,
    controller: PackageConfigurationsTableComponent
  });
